import { useQuery } from "react-query";
import {
  DashboardConciliacaoBancariaResponse,
} from "../typings";
import { AxiosError } from "axios";
import  http  from 'infra/http';
import { DashboardConciliacaoQuery } from '../typings/index';

function useDashboardConciliacaoBancaria(query: DashboardConciliacaoQuery) {
  return useQuery<DashboardConciliacaoBancariaResponse, AxiosError>(
    [`/v1/extrato-bancario/dashboard`, query],
    async () => {
      const {data} = await http.get<DashboardConciliacaoBancariaResponse>('/v1/extrato-bancario/dashboard', {
        params: query
      })

      return data;
    }
  );
}

export default useDashboardConciliacaoBancaria;
